import { HttpResponse, HttpService } from '@application/http.service';
import type { RateApiModel } from '@visiba/api-vcs-client-v2';
import { Injectable } from '@visiba/instantiation';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class RateApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('rate');
	}

	public getMessagingConversationPrice(receptionId: number): HttpResponse<RateApiModel> {
		return this.httpService.get(`${this.baseUri}/${receptionId}/getMessagingConversationPrice`);
	}
}
